// Derives the guest checkout stepper state from booking state (payment /
// verification status) rather than from which page is mounted.
const CHECKOUT_STEP_KEYS = ['stepOne', 'stepTwo', 'stepThree'];

const visibleCheckoutSteps = includeVerification =>
  includeVerification
    ? CHECKOUT_STEP_KEYS
    : CHECKOUT_STEP_KEYS.filter(step => step !== 'stepTwo');

// True when any supported verification requirement (signature, ID photo,
// age, address) applies. Accepts either checkout responses (verify_image)
// or verification responses (verify_id).
const checkoutVerificationRequired = requirements =>
  Boolean(
    requirements &&
      (requirements.verify_signature ||
        requirements.verify_image ||
        requirements.verify_id ||
        requirements.verify_age ||
        requirements.verify_address)
  );

const bookingBalanceDue = data => {
  const booking = (data && data.booking) || {};
  if (!data || booking.cancelled) return false;
  // The receipt/payment endpoints report the amount currently owed, which is
  // 0 once today's required payment settles even when a later installment is
  // still scheduled.
  if (data.payment_due_today !== undefined && data.payment_due_today !== null) {
    return Number(data.payment_due_today) > 0;
  }
  const remaining =
    booking.price_remaining !== undefined && booking.price_remaining !== null
      ? booking.price_remaining
      : (booking.price_total || 0) - (booking.price_paid || 0);
  return Number(remaining) > 0;
};

// requirements: the effective verification requirements for the booking
// (e.g. from the verification endpoint, which honors active ExternalContract
// overrides). Falls back to the brand-level flags when not provided.
const deriveCheckoutStepState = (data, brand, requirements) => {
  const booking = (data && data.booking) || {};
  const verificationOutstanding = Boolean(
    data && data.verified === false && !booking.cancelled
  );
  const effectiveRequirements =
    requirements ||
    (brand && {
      verify_signature: brand.verify_signature,
      verify_image: brand.verify_image
    });
  let checkoutActiveStep = 'stepThree';
  if (bookingBalanceDue(data)) {
    checkoutActiveStep = 'stepOne';
  } else if (verificationOutstanding) {
    checkoutActiveStep = 'stepTwo';
  }
  return {
    checkoutActiveStep,
    checkoutVisibleSteps: visibleCheckoutSteps(
      verificationOutstanding ||
        checkoutVerificationRequired(effectiveRequirements)
    )
  };
};

module.exports = {
  checkoutVerificationRequired,
  deriveCheckoutStepState,
  visibleCheckoutSteps
};
